import React from 'react';
import Ellips from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import OuterUrlLink from '../../../common/outerUrlLink/OuterUrlLink';
import {isNotEmpty, fieldAnomaly} from '../../../../utils/util';

// 公司信息
export const publicCompany = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 80
    },
    {
        title: '公司代码',
        dataIndex: 'stock_code',
        width: 90
    },
    {
        title: '公司简称',
        dataIndex: 'stock_short',
        width: 100
    }
];

// SSE publicTitle
export const publicTitle = [
    {
        title: '附件标题',
        dataIndex: 'attachment_title'
    },
    {
        title: '附件url',
        dataIndex: 'attachment_url',
        render: v => <a target="_blank" rel="noopener noreferrer" href={v}>{v ? '查看' : '--'}</a>
    }
];

export const publicSZSETitle = [
    {
        title: '附件url',
        dataIndex: 'attachment_url',
        render: v => <OuterUrlLink url={v} text={'查看'} />
    },
    {
        title: '函件内容',
        dataIndex: 'attachment_title'
    }
];

// 公用表头
export function commonColumns(title){
    let data = [
        {
            title: '序号',
            dataIndex: 'index'
        },
        {
            title: '文书号',
            dataIndex: 'punish_code'
        },
        {
            title: '处罚机关',
            dataIndex: 'punish_org',
            render: fieldAnomaly
        },
        {
            title: '处罚对象',
            dataIndex: 'name'
        },
        {
            title: '时间',
            dataIndex: 'public_date',
            render: fieldAnomaly
        }
    ];
    if(isNotEmpty(title)) {
        data.splice(4, 0, ...title);
    }
    return data;
}

// 上海证券交易所 承诺履行
export const ssePromise = [
    ...publicCompany,
    {
        title: '承诺类型',
        dataIndex: 'promise_type',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺主体类型',
        dataIndex: 'promise_subject_type',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺主体名称',
        dataIndex: 'promise_subject_name',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺事项类别',
        dataIndex: 'promise_item_type',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺内容',
        dataIndex: 'promise_content',
        render: (v, d) => <OuterUrlLink url={d.promise_content_url} HiddenUrl={true} text={v} />
    },
    {
        title: '目前履行状态',
        dataIndex: 'perform_status'
    },
    {
        title: '承诺履行违规情形',
        dataIndex: 'irregularities',
        render: v => v ? v : '--'
    },
    {
        title: '预计履行完成时间',
        dataIndex: 'expected_end_time',
        render: v => v ? v : '--'
    },
    {
        title: '实际履行完成时间',
        dataIndex: 'actually_end_time',
        render: v => v ? v : '--'
    }
];

// 上海证券交易所 问询
export const sseEnquiry = [
    ...publicCompany,
    {
        title: '发函日期',
        dataIndex: 'pubdate'
    },
    {
        title: '监管类型',
        dataIndex: 'notice_type',
        render: text => <Ellips text={text} />
    },
    {
        title: '标题',
        dataIndex: 'notice_name',
        render: (v, d) => <OuterUrlLink url={d.attachment_url} HiddenUrl={true} text={v} />
    }
];

// 深圳证券交易所 承诺履行
export const szseDegree = [
    ...publicCompany,
    {
        title: '承诺主体',
        dataIndex: 'promise_subject_name',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺类别',
        dataIndex: 'promise_item_type',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺开始日期',
        dataIndex: 'promise_start_time'
    },
    {
        title: '承诺结束日期',
        dataIndex: 'promise_end_time'
    },
    {
        title: '履行情况',
        dataIndex: 'perform_status',
        render: text => <Ellips text={text} />
    },
    {
        title: '承诺内容',
        dataIndex: 'promise_content',
        render: text => <Ellips text={text} />
    }
];

// 深圳证券交易所 处罚与处分记录
export const szsePunish = [
    ...publicCompany,
    {
        title: '处分类别',
        dataIndex: 'punish_type'
    },
    {
        title: '当事人',
        dataIndex: 'punish_subject',
        render: text => <Ellips text={text} />
    },
    {
        title: '标题',
        dataIndex: 'title',
        render: (v, d) => <OuterUrlLink url={d.attachment_url} HiddenUrl={true} text={v} />
    },
    {
        title: '处分日期',
        dataIndex: 'punish_date'
    }
];

// 深圳证券交易所 问询函件
export const szseEnquiry = [
    ...publicCompany,
    {
        title: '发函日期',
        dataIndex: 'pubdate'
    },
    {
        title: '函件类别',
        dataIndex: 'notice_type'
    },
    {
        title: '函件内容',
        dataIndex: 'notice_name'
    },
    {
        title: '公司回复',
        dataIndex: 'reply_name', 
        render: (v, d) => <OuterUrlLink url={d.attachment_url_1 || d.attachment_url_2} HiddenUrl={true} text={v} />
    }
];

// 深圳证券交易所 监管措施
export const szseMeasures = [
    ...publicCompany,
    {
        title: '采取监管措施日期',
        dataIndex: 'pubdate'
    },
    {
        title: '监管措施',
        dataIndex: 'notice_measures'
    },
    {
        title: '函件内容',
        dataIndex: 'notice_name',
        render: (v, d) => <OuterUrlLink url={d.attachment_url} HiddenUrl={true} text={v} />
    },
    {
        title: '涉及对象',
        dataIndex: 'notice_target',
        render: text => <Ellips text={text} />
    }
];


// WEBPACK FOOTER //
// ./src/components/financialPicture/historyPunishment/subComponents/columns.jsx